"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Button_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Button"));
var Loader_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Loader"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var endOfMonth_1 = tslib_1.__importDefault(require("date-fns/endOfMonth"));
var startOfMonth_1 = tslib_1.__importDefault(require("date-fns/startOfMonth"));
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var utilities_2 = require("../../../utilities/utilities");
var Header_1 = tslib_1.__importDefault(require("../../../view/components/Header"));
var MatchesList_1 = tslib_1.__importDefault(require("./MatchesList"));
var utilities_3 = require("./utilities");
var AspectRatioWrapper = styled_components_1["default"]('div')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  padding-top: ", "%;\n"], ["\n  position: relative;\n  width: 100%;\n  padding-top: ", "%;\n"])), function (_a) {
    var scWidth = _a.scWidth, scHeight = _a.scHeight;
    return 100 / (scWidth / scHeight);
});
var AspectRatioContentWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  background-color: #fff;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  background-color: #fff;\n"])));
var Wrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-size: ", ";\n  ", "\n  ", " {\n    margin: 0;\n    width: 100%;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-size: ", ";\n  ",
    "\n  ", " {\n    margin: 0;\n    width: 100%;\n  }\n"])), polished_1.rem(12), function (_a) {
    var theme = _a.theme;
    return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    margin: 0 -", ";\n    width: calc(100% + ", ");\n  "], ["\n    margin: 0 -", ";\n    width: calc(100% + ", ");\n  "])), polished_1.rem(theme.grid.gutterWidth / 2), polished_1.rem(theme.grid.gutterWidth));
}, utilities_1.mb('m'));
var TitleWrapper = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var LoaderWrapper = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var Title = styled_components_1["default"](Header_1["default"])(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  && {\n    > h2 {\n      font-size: ", ";\n      font-weight: bold;\n    }\n  }\n"], ["\n  && {\n    > h2 {\n      font-size: ", ";\n      font-weight: bold;\n    }\n  }\n"])), polished_1.rem(18));
var NotFoundWrapper = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var ErrorWrapper = styled_components_1["default"].div(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  color: red;\n"], ["\n  text-align: center;\n  color: red;\n"])));
var LoadMoreWrapper = styled_components_1["default"].div(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  margin-top: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"], ["\n  margin-top: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"])), polished_1.rem(16));
var LoadMoreButton = styled_components_1["default"](Button_1["default"])(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n  && {\n    width: max-content;\n    margin-top: ", ";\n  }\n"], ["\n  && {\n    width: max-content;\n    margin-top: ", ";\n  }\n"])), polished_1.rem(16));
var RaceMatchesListWidget = function (_a) {
    var _b, _c, _d, _e, _f;
    var theme = _a.theme, renderLink = _a.renderLink, widgetData = _a.data, renderEmpty = _a.renderEmpty;
    var date = React.useState(null)[0];
    var _g = React.useState({
        matches: ((_b = widgetData === null || widgetData === void 0 ? void 0 : widgetData.data) === null || _b === void 0 ? void 0 : _b.matches) || [],
        total: (_d = (_c = widgetData === null || widgetData === void 0 ? void 0 : widgetData.data) === null || _c === void 0 ? void 0 : _c.total) !== null && _d !== void 0 ? _d : 0,
        nextOffset: (_f = (_e = widgetData === null || widgetData === void 0 ? void 0 : widgetData.data) === null || _e === void 0 ? void 0 : _e.nextOffset) !== null && _f !== void 0 ? _f : null
    }), matchesList = _g[0], setMatchesList = _g[1];
    var _h = React.useState(false), isLoading = _h[0], setIsLoading = _h[1];
    var _j = React.useState(''), error = _j[0], setError = _j[1];
    var _k = React.useState(false), isLoadMoreLoading = _k[0], setIsLoadMoreLoading = _k[1];
    React.useEffect(function () {
        (function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var resp, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!date) return [3 /*break*/, 5];
                        setIsLoading(true);
                        setError('');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, utilities_3.getMatches(widgetData, {
                                dateFrom: startOfMonth_1["default"](date),
                                dateTo: endOfMonth_1["default"](date)
                            })];
                    case 2:
                        resp = _a.sent();
                        setMatchesList({
                            matches: resp.matches,
                            total: resp.total,
                            nextOffset: resp.nextOffset
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        setError(err_1.message || err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
    }, [widgetData, date, setMatchesList, setIsLoading, setError]);
    if (!widgetData.competitionId && !widgetData.teamId && renderEmpty) {
        return React.createElement(React.Fragment, null, renderEmpty('raceMatchesList'));
    }
    if (!widgetData.data) {
        return null;
    }
    var handleLoadMoreClick = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var params, resp_1, err_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {};
                    if (matchesList.nextOffset) {
                        params.offset = matchesList.nextOffset;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsLoadMoreLoading(true);
                    return [4 /*yield*/, utilities_3.getMatches(widgetData, params)];
                case 2:
                    resp_1 = _a.sent();
                    setMatchesList(function (prev) {
                        return tslib_1.__assign(tslib_1.__assign({}, resp_1), { matches: tslib_1.__spreadArrays(prev.matches, resp_1.matches) });
                    });
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    setError(err_2.message || err_2);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoadMoreLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var renderWidgetContent = function () { return (React.createElement(Wrapper, null,
        widgetData.title && (React.createElement(TitleWrapper, null,
            React.createElement(Title, null, widgetData.title))),
        isLoading ? (React.createElement(LoaderWrapper, null,
            React.createElement(Loader_1["default"], { size: "l" }))) : (React.createElement(React.Fragment, null, error ? (React.createElement(ErrorWrapper, null, error)) : (React.createElement(React.Fragment, null, matchesList && matchesList.matches.length > 0 ? (React.createElement(React.Fragment, null,
            React.createElement(MatchesList_1["default"], { renderLink: renderLink, matchesList: matchesList, theme: theme }),
            React.createElement(LoadMoreWrapper, null, matchesList.nextOffset && (React.createElement(LoadMoreButton, { primary: true, loading: isLoadMoreLoading, onClick: handleLoadMoreClick }, utilities_2.__('Zobraziť viac')))))) : (React.createElement(NotFoundWrapper, null, utilities_2.__('Pre zvolené kritériá, alebo časové obdobie, neboli nájdené žiadne zápasy.'))))))))); };
    var ratio = widgetData.ratio ? widgetData.ratio.split(':') : null;
    return (React.createElement("div", { className: "content-widget-matchesList" }, ratio && ratio.length === 2 ? (React.createElement(AspectRatioWrapper, { scWidth: Number(ratio[0]), scHeight: Number(ratio[1]) },
        React.createElement(AspectRatioContentWrapper, null, renderWidgetContent()))) : (renderWidgetContent())));
};
exports["default"] = RaceMatchesListWidget;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
